import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getIsMsgOutgoing } from 'widget/actions';
import { Text } from 'widget/components';
import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useConvoContext } from '../../../../convo-context';
import { useIsMutedDark, useMuted } from 'widget/hooks';
import { useMsgContext } from '../../msg-context';

import { useMsgPreview } from './hooks';

const QuotedMsg = () => {
  const { accessToken } = useChatBodyContext();
  const { messageList } = useConvoContext();
  const { msg } = useMsgContext();

  const [target, setTarget] = useState<HTMLDivElement | null>();

  const { t } = useTranslation();
  const isMsgOutgoing = getIsMsgOutgoing(accessToken, msg);
  const isMutedDark = useIsMutedDark();

  const quotedMsg = messageList.find(item => item.id == msg.quotedMsgId);
  const msgPreview = useMsgPreview(quotedMsg);
  const muted = useMuted();

  const getTarget = () => {
    if (target) return target;

    const el: HTMLDivElement | null = document.querySelector(
      `[data-msg-id="${msg.quotedMsgId}"]`,
    );

    setTarget(el);
    return el;
  };

  const handleClick = async () => {
    const target = getTarget();
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    await new Promise(resolve =>
      setTimeout(
        () => resolve(target.classList.add('whatcrm-widget-message_active')),
        150,
      ),
    );

    setTimeout(
      () => target.classList.remove('whatcrm-widget-message_active'),
      300,
    );
  };

  const color = isMutedDark ? 'white' : 'dark';
  const isQuotedMsgOutgoing = getIsMsgOutgoing(accessToken, quotedMsg);

  return (
    <>
      {quotedMsg && (
        <button
          className="whatcrm-widget-message__quoted-message"
          disabled={target === null}
          onClick={handleClick}
          style={{
            background: isMsgOutgoing
              ? muted
              : isMutedDark
                ? '#7f7f7f'
                : '#dfdfdf',
            marginBottom: 8,
          }}
        >
          <div className="whatcrm-widget-message__quote">
            <Text color={color} fontSize={12} fontWeight={600}>
              {isQuotedMsgOutgoing
                ? t`You`
                : quotedMsg.sender_name || t`Manager`}
            </Text>

            <Text color={color} fontSize={12} isEllipsis>
              {msgPreview}
            </Text>
          </div>
        </button>
      )}
    </>
  );
};

export default QuotedMsg;
